@include section-styles(0px, 0px);

.content {
  @include text-main;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.headline, .content {
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
  font-family: var(--font-main);
  font-size: var(--highlight--text-size-l);
  line-height: 1.05;
  letter-spacing: -0.015em;
  position: relative;
}

.headline {
  padding-bottom: 30px;
  @include text-bold;
}

video {
    position: absolute;
    top: 0;
    bottom: 0;
    left:0;
    right:0;
    width: 100%;
    object-fit: cover;
    height: auto;
    min-width: 100%;
}
.sentence {
    -webkit-transition: color 0.2s linear;
    -moz-transition: color 0.2s linear;
    -o-transition: color 0.2s linear;
    transition: color 0.2s linear;
    color: var(--highlight--inactive-text-color);
}
.li {
    display: block;
    line-height: 130%;
}
.text-active {
    color: var(--highlight--active-text-color);
}

sub, sup {
    font-size: 70%;
}

@include media-max-width($breakpoint-l) {

  /* use default section padding
    section {
        padding: 50px 0;
    }
   */

    .headline, .content {
        @include text-bold;
        max-width: 692px;
        font-size: var(--highlight--text-size-m);
        line-height: 1.0625;
        letter-spacing: -0.009em;
    }

    video {
        top: 50px;
        bottom: 50px;
    }
}

@include media-max-width($breakpoint-m) {
    section {
        padding: 30px 0;
    }

    .headline, .content {
        @include text-bold;
        max-width: 87.5%;
        font-size: var(--highlight--text-size-s);
        line-height: 1.125;
        letter-spacing: .004em;
    }

    video {
        top: 30px;
        bottom: 30px;
    }
    .li {
        padding-left: 25px;

        /*
        &:before {
            padding-right: 15px;
            line-height: 60px;
        }*/
    }
}
